import React from 'react'
import Image from 'next/image'
import Link from 'next/link'

import elixirImg from '../../../public/images/elixir.png'
import CheckMark from './CheckMark'
import { ICourse } from '../types'

interface IProps {
  course: ICourse
}

const CourseCard = (props: IProps) => {
  const { course } = props

  const { name, section, slug, content, metadata } = course
  const titleLink = `/${section}/${slug}`
  const topics = [
    'Qué es',
    'Erlang',
    'Historia',
    'Sintaxis',
    'Estructuras de datos',
    'Programación Funcional',
  ]
  const checkTopics = topics.map((item, index) => {
    return <CheckMark key={`check-${index}`} text={item} />
  })
  return (
    <div className='block dark:border-jacarta-600 border-jacarta-100 rounded-lg bg-white border  dark:bg-jacarta-700 rounded-2xl overflow-hidden transition-shadow hover:shadow-lg dark:hover:shadow-jacarta-100 mb-[1.875rem]'>
      <div className='flex flex-wrap items-center'>
        <div className='block w-full shrink-0 grow-0 basis-auto lg:flex lg:w-6/12 xl:w-4/12'>
          <Image
            src={elixirImg}
            alt='Elixir language'
            priority={true}
            className='w-full rounded-t-lg lg:rounded-tr-none lg:rounded-bl-lg'
            height={100}
          />
        </div>
        <div className='p-6 w-full shrink-0 grow-0 basis-auto lg:w-6/12 xl:w-8/12'>
          <h2 className='mb-6 pb-2 text-3xl font-bold'>
            <Link href={titleLink}>{metadata.title}</Link>
          </h2>
          <p className='mb-6 pb-2 text-neutral-500 dark:text-neutral-300'>
            {metadata.description}
          </p>
          <div className='mb-6 flex flex-wrap'>{checkTopics}</div>
        </div>
      </div>
    </div>
  )
}
export default CourseCard
